// CyberSentriq labels are stored in Ditto WITHOUT a trailing colon — the colon
// is a presentation separator (see the `-lead-in` / trailing-colon contract and
// docs/ditto-guidelines.md). This shared helper renders the separator for
// "label: value" rows so no component hardcodes it and stored copy stays
// colon-free. Locale-aware and idempotent.
//
// Usage:  {{ appendColon($t("enrolled-sat-users"), locale) }}  ->  "Enrolled users:"

// Separator per language subtag. French typography puts a space before the
// colon; extend as locales are added. Unknown locales fall back to ":".
const SEPARATORS: Record<string, string> = {
  en: ":",
  fr: " :",
};

export function appendColon(label: string, locale = "en"): string {
  if (!label) return label ?? "";
  const trimmed = label.trimEnd();
  if (!trimmed) return "";
  if (trimmed.endsWith(":")) return trimmed; // already separated — don't double
  const lang = locale.split("-")[0].toLowerCase();
  return trimmed + (SEPARATORS[lang] ?? SEPARATORS.en);
}
